var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-form login-container" },
    [
      _c(
        "transition",
        { attrs: { name: "fade-fast", mode: "out-in" } },
        [
          _vm.action === "success"
            ? _c(
                "div",
                {
                  staticClass: "feedback",
                  style: _vm.feedbackStyle,
                  attrs: { id: "login" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "message", style: _vm.messageStyle },
                    [
                      _vm._v(
                        "Success! The page should reload with you logged in. If it takes too long, click the button to reload."
                      ),
                    ]
                  ),
                  _c(
                    "b-btn",
                    {
                      staticClass: "mid-button",
                      attrs: { variant: "primary" },
                      on: { click: _vm.reload },
                    },
                    [_vm._v("reload")]
                  ),
                ],
                1
              )
            : _vm.action === "success-email"
            ? _c(
                "div",
                {
                  staticClass: "feedback",
                  style: _vm.feedbackStyle,
                  attrs: { id: "login" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "message", style: _vm.messageStyle },
                    [
                      _vm._v(
                        "Success! Please check your mail and follow the confirmation link to complete registration"
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "login-actions" },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "mid-button",
                          attrs: { variant: "primary" },
                          on: { click: _vm.reload },
                        },
                        [_vm._v("OK")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm.action === "link-sent"
            ? _c(
                "div",
                {
                  staticClass: "feedback",
                  style: _vm.feedbackStyle,
                  attrs: { id: "login" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "message", style: _vm.messageStyle },
                    [
                      _vm._v(
                        "Your login link has been sent. This page should reload once you've been logged in. If not, click the button to reload"
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "login-actions" },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "mid-button",
                          attrs: { variant: "primary" },
                          on: { click: _vm.reload },
                        },
                        [_vm._v("reload")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm.action === "not-registered"
            ? _c(
                "div",
                {
                  staticClass: "feedback",
                  style: _vm.feedbackStyle,
                  attrs: { id: "login" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "message", style: _vm.messageStyle },
                    [
                      _vm._v("The username "),
                      _c("strong", [_vm._v(_vm._s(_vm.formData.login))]),
                      _vm._v(" is not registered. Would you like to sign up?"),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "login-actions" },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "login-button",
                          attrs: { variant: "link" },
                          on: { click: _vm.goBack },
                        },
                        [_vm._v("go back")]
                      ),
                      _c(
                        "b-btn",
                        {
                          staticClass: "register-button",
                          attrs: { variant: "success" },
                          on: { click: _vm.register },
                        },
                        [_vm._v("sign-up")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm.action === "email-exists"
            ? _c(
                "div",
                {
                  staticClass: "feedback",
                  style: _vm.feedbackStyle,
                  attrs: { id: "login" },
                },
                [
                  _vm.formData.token
                    ? [
                        _c(
                          "div",
                          { staticClass: "message", style: _vm.messageStyle },
                          [
                            _vm._v("The email "),
                            _c("strong", [_vm._v(_vm._s(_vm.formData.email))]),
                            _vm._v(
                              " is already registered. If this email is correct, click confirm to get your login link, or go back to change it"
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "login-actions" },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "login-button",
                                attrs: { variant: "link" },
                                on: { click: _vm.goBack },
                              },
                              [_vm._v("go back")]
                            ),
                            _c(
                              "b-btn",
                              {
                                staticClass: "register-button",
                                attrs: { variant: "success" },
                                on: { click: _vm.confirm },
                              },
                              [_vm._v("confirm")]
                            ),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c(
                          "div",
                          { staticClass: "message", style: _vm.messageStyle },
                          [
                            _vm._v("The email "),
                            _c("strong", [_vm._v(_vm._s(_vm.formData.email))]),
                            _vm._v(
                              " is already registered but does not match the password given. If this email is correct, click login to try again, or click forgot password and a login link will be sent to you."
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "login-actions" },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "login-button",
                                attrs: { variant: "link" },
                                on: { click: _vm.goToLogin },
                              },
                              [_vm._v("login")]
                            ),
                            _c(
                              "b-btn",
                              {
                                staticClass: "register-button",
                                attrs: { variant: "success" },
                                on: { click: _vm.confirm },
                              },
                              [_vm._v("forgot password")]
                            ),
                          ],
                          1
                        ),
                      ],
                ],
                2
              )
            : _vm.action === "unknown-user"
            ? _c(
                "b-form",
                {
                  ref: "formData",
                  class: ["login", _vm.action],
                  attrs: { id: "login" },
                  on: { submit: _vm.login, click: _vm.formClick },
                },
                [
                  _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      "We're sorry, we don't have that username on record. Please check and re-enter the username or use your email address. Hit sign-up to create a new account."
                    ),
                  ]),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "login-username",
                        label: "email address",
                        "label-for": "username",
                      },
                    },
                    [
                      _c("b-form-input", {
                        ref: "firstInput",
                        attrs: { id: "username", type: "text", required: "" },
                        on: { change: _vm.changed },
                        model: {
                          value: _vm.formData.login,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "login", $$v)
                          },
                          expression: "formData.login",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { staticClass: "login-actions" },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "login-button",
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            name: "wp-submit",
                            value: "Log in",
                          },
                          on: { click: _vm.actionLogin },
                        },
                        [_vm._v("try again")]
                      ),
                      _c(
                        "b-btn",
                        {
                          staticClass: "register-button",
                          attrs: {
                            type: "submit",
                            variant: "success",
                            name: "wp-submit",
                            value: "Register",
                          },
                          on: { click: _vm.actionRegister },
                        },
                        [_vm._v("sign-up")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.action === "unknown-email"
            ? _c(
                "b-form",
                {
                  ref: "formData",
                  class: ["login", _vm.action],
                  attrs: { id: "login" },
                  on: { submit: _vm.login, click: _vm.formClick },
                },
                [
                  _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      "We're sorry, we have no record of that email address. If you entered the email incorrectly you can re-enter it below to retry. or hit sign-up to create an account"
                    ),
                  ]),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "login-email",
                        label: "email address",
                        "label-for": "email",
                      },
                    },
                    [
                      _c("b-form-input", {
                        ref: "firstInput",
                        attrs: { id: "email", type: "email", required: "" },
                        on: { change: _vm.changed },
                        model: {
                          value: _vm.formData.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "email", $$v)
                          },
                          expression: "formData.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { staticClass: "login-actions" },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "login-button",
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            name: "wp-submit",
                            value: "Log in",
                          },
                          on: { click: _vm.actionLogin },
                        },
                        [_vm._v("try again")]
                      ),
                      _c(
                        "b-btn",
                        {
                          staticClass: "register-button",
                          attrs: {
                            type: "submit",
                            variant: "success",
                            name: "wp-submit",
                            value: "Register",
                          },
                          on: { click: _vm.actionRegister },
                        },
                        [_vm._v("sign-up")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "b-form",
                {
                  ref: "formData",
                  class: ["login", _vm.action],
                  attrs: { id: "login" },
                  on: { submit: _vm.login, click: _vm.formClick },
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade-fast" } },
                    [
                      _vm.errors.length
                        ? _c(
                            "b-form-group",
                            _vm._l(_vm.errors, function (error, index) {
                              return _c("b-alert", {
                                key: index,
                                attrs: { variant: "danger", show: "" },
                                domProps: { innerHTML: _vm._s(error) },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "login-username",
                        label:
                          _vm.action === "register"
                            ? "username"
                            : "username or email address",
                        "label-for": "username",
                      },
                    },
                    [
                      _c("b-form-input", {
                        ref: "firstInput",
                        attrs: { id: "username", type: "text", required: "" },
                        on: { change: _vm.changed },
                        model: {
                          value: _vm.formData.login,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "login", $$v)
                          },
                          expression: "formData.login",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "transition",
                    { attrs: { name: "fade-fast" } },
                    [
                      _vm.action === "register"
                        ? _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "login-email",
                                label: "email address",
                                "label-for": "email",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "email",
                                  type: "email",
                                  required: "",
                                },
                                on: { change: _vm.changed },
                                model: {
                                  value: _vm.formData.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "email", $$v)
                                  },
                                  expression: "formData.email",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "transition",
                    { attrs: { name: "fade-fast", mode: "out-in" } },
                    [
                      _vm.tokenLogin
                        ? _c(
                            "div",
                            { attrs: { id: "login-password" } },
                            [
                              _vm.action === "register"
                                ? [
                                    _c("b-alert", { attrs: { show: "" } }, [
                                      _vm._v(
                                        "A password will be generated for you and sent with your confirmation email."
                                      ),
                                    ]),
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: { click: _vm.enterPass },
                                      },
                                      [_vm._v("set password now")]
                                    ),
                                  ]
                                : [
                                    _c("b-alert", { attrs: { show: "" } }, [
                                      _vm._v(
                                        "An email will be sent with a link that will log you in when you click it. This link will expire in 10 minutes."
                                      ),
                                    ]),
                                    _vm.passwordWrong
                                      ? _c(
                                          "b-btn",
                                          {
                                            attrs: { variant: "link" },
                                            on: { click: _vm.enterPass },
                                          },
                                          [_vm._v("try enter password again")]
                                        )
                                      : _c(
                                          "b-btn",
                                          {
                                            attrs: { variant: "link" },
                                            on: { click: _vm.enterPass },
                                          },
                                          [_vm._v("enter password instead")]
                                        ),
                                  ],
                            ],
                            2
                          )
                        : _vm.action === "register"
                        ? _c(
                            "b-form-group",
                            { attrs: { id: "login-password" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "login-password1",
                                    label: "password",
                                    "label-for": "password1",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "password1",
                                      type: "password",
                                      required: "",
                                    },
                                    on: { change: _vm.changed },
                                    model: {
                                      value: _vm.formData.pass,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "pass", $$v)
                                      },
                                      expression: "formData.pass",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "login-password2",
                                    label: "confirm password",
                                    "label-for": "password2",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "password2",
                                      type: "password",
                                      required: "",
                                    },
                                    on: { change: _vm.changed },
                                    model: {
                                      value: _vm.confirmPass,
                                      callback: function ($$v) {
                                        _vm.confirmPass = $$v
                                      },
                                      expression: "confirmPass",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-btn",
                                {
                                  attrs: { variant: "link" },
                                  on: { click: _vm.sendLink },
                                },
                                [_vm._v("don't set password now")]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "login-password",
                                label: "password",
                                "label-for": "password",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "password",
                                  type: "password",
                                  required: "",
                                },
                                on: { change: _vm.changed },
                                model: {
                                  value: _vm.formData.pass,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "pass", $$v)
                                  },
                                  expression: "formData.pass",
                                },
                              }),
                              _vm.passwordWrong
                                ? _c(
                                    "b-btn",
                                    {
                                      attrs: { variant: "link" },
                                      on: { click: _vm.sendLink },
                                    },
                                    [_vm._v("forgot password")]
                                  )
                                : _c(
                                    "b-btn",
                                    {
                                      attrs: { variant: "link" },
                                      on: { click: _vm.sendLink },
                                    },
                                    [_vm._v("email login link instead")]
                                  ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _vm.recaptcha.show || !_vm.recaptcha.response
                        ? _c(
                            "b-form-group",
                            { attrs: { id: "login-recaptcha" } },
                            [
                              _c("vue-recaptcha", {
                                attrs: {
                                  sitekey: _vm.recaptcha.key,
                                  theme: "dark",
                                },
                                on: {
                                  rendered: _vm.recaptchaShow,
                                  verify: _vm.recaptchaSuccess,
                                  expired: _vm.recaptchaExpired,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { staticClass: "login-actions" },
                    [
                      _vm.action != "register"
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "login-button",
                              attrs: {
                                type: "submit",
                                variant: "primary",
                                name: "wp-submit",
                                value: "Log in",
                              },
                              on: { click: _vm.actionLogin },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.tokenLogin ? "send link" : "login")
                              ),
                            ]
                          )
                        : _c(
                            "b-btn",
                            {
                              staticClass: "login-button",
                              attrs: { variant: "link" },
                              on: { click: _vm.clearForm },
                            },
                            [_vm._v("cancel")]
                          ),
                      _vm.action != "register"
                        ? _c("span", [_vm._v("or")])
                        : _vm._e(),
                      _c(
                        "b-btn",
                        {
                          staticClass: "register-button",
                          attrs: {
                            type: "submit",
                            variant: "success",
                            name: "wp-submit",
                            value: "Register",
                          },
                          on: { click: _vm.actionRegister },
                        },
                        [_vm._v("sign-up")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }